/* eslint no-underscore-dangle: 0 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Joyride from 'react-joyride';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import {
  Outlet,
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// import Register from '../Register';
// import RegisterNew from '../RegisterNew';
import RegisterNew from '../Register/RegisterNew';
// import Login from '../Login';
import Login from '../LoginNew';
import SideBar from '../../shared/component/SideBar';
// import Header from '../../shared/component/Header';
// import MyContent from '../MyContent';
// import ForgotPassword from '../ForgotPassword';
import ForgotPasswordNew from '../ForgotPassword/ForgotPasswordNew';
// import ResetPassword from '../ResetPassword';
import Notification from '../../shared/component/Notification';
// import Footer from '../../shared/component/Footer';
import Templates from '../Templates';
import TableRenderPage from '../Templates/components/TableRenderPage';
import HtmlRenderPage from '../Templates/components/HtmlRenderPage';

import styles from '../../assets/json/joyride-styles.json';

import backRoutes from '../../assets/json/previous-navigate-steps.json';
import nextRoutes from '../../assets/json/next-navigate-steps.json';
// import StyleRenderPage from '../Templates/components/StyleRenderPage';
// User Api
import userApi from '../../utils/api/users';
import { setErrorNotification } from '../../redux/slices/NotificationSlice';
import {
  setLocalStorageItem,
  checkFeatures,
  checkPermission,
  getI18Next,
} from '../../utils/helpers';
import WalkthroughSteps from './WalkthroughSteps';
import AuthGuard from './AuthGuard';
import NotFoundPage from './NotFoundPage';

import {
  ContentManagementIcon,
  ContentActiveManagementIcon,
} from '../../shared/component/svgIcon';
import ViewImage from '../Templates/components/viewImage';
// import WeatherComponent from '../Widgets/components/Weather/WeatherComponent';
import NotificationMessage from '../../shared/component/NotificationMessage';
import ResetPasswordNew from '../ResetPassword/ResetPasswordNew';

const routsData = [
  {
    path: 'my-content',
    children: [
      {
        path: '',
        permission: [
          { modal: 'content', name: 'view', permission: 'getContent' },
        ],
        component: <Navigate to="list" />,
      },
      // {
      //   path: ':page',
      //   permission: [
      //     { modal: 'content', name: 'view', permission: 'getContent' },
      //   ],
      //   component: <MyContent />,
      // },
    ],
  },
  {
    path: 'templates',
    children: [
      {
        path: '',
        permission: [
          { modal: 'templates', name: 'view', permission: 'getTemplatesList' },
        ],
        component: <Templates />,
      },
      {
        path: 'edit-content/:id',
        permission: [
          { modal: 'templates', name: 'create', permission: 'getTemplatesList' },
        ],
        component: <TableRenderPage />,
      },
      {
        path: 'view-html/:id',
        permission: [
          { modal: 'templates', name: 'create', permission: 'getTemplatesList' },
        ],
        component: <HtmlRenderPage />,
      },
      {
        path: 'view-image/:id',
        permission: [
          { modal: 'templates', name: 'view', permission: 'getTemplatesList' },
        ],
        component: <ViewImage />,
      },
    ],
  },
];

function WrapperRoutes() {
  const { t } = useTranslation();
  const currentLanguageCode = getI18Next();
  const [drawerOpen, setDrawerOpen] = useState(false); // State to manage drawer open/close
  const [sidebarMenu, setSideBarMenu] = useState([
    {
      id: 2,
      name: t('templateBuilder'),
      accordion: false,
      svgIcon: <ContentManagementIcon />,
      svgActiveIcon: <ContentActiveManagementIcon />,
      showAccordionArrow: true,
      enable: (checkPermission('getContent') && checkFeatures('content', 'view'))
        || (checkPermission('getTemplatesList') && checkFeatures('templates', 'view'))
        || (checkPermission('getApps') && checkFeatures('apps', 'view'))
        || (checkPermission('getLayouts') && checkFeatures('layouts', 'view')),
      subMenus: [
        {
          name: t('Templates'),
          class: 'menu',
          activeClass: 'menu active',
          url: '/admin/templates',
          active: '/admin/templates',
          enable: checkPermission('getTemplatesList') && checkFeatures('templates', 'view'),
          key: 'Templates',
        },
      ],
    },
  ]);
  return (
    <div>
      <div className="layout">
        <div className="sidebar-session">
          <SideBar
            sidebarMenu={sidebarMenu}
            setSideBarMenu={setSideBarMenu}
            setDrawerOpen={setDrawerOpen}
            drawerOpen={drawerOpen}
          />
        </div>
        <div className="main-session">
          <div className="content-session">
            <div className={`outlet-container ${currentLanguageCode === 'ar' ? 'rtl' : ''}`}>
              <Outlet />
            </div>
            {/* <Footer /> */}
          </div>
        </div>
        {/* <Notification /> */}
      </div>
    </div>
  );
}

function WrapperRoutes2() {
  return (
    <div>
      <div className="layout">
        <Outlet />
      </div>
    </div>
  );
}

function Router() {
  const data = JSON.parse(localStorage.getItem('data'));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locate = useLocation();
  const { t } = useTranslation();
  const currentLanguageCode = getI18Next();

  const currentPath = locate.pathname;
  const [stepIndex, setStepIndex] = useState(0);
  const [runWalkthrough, setRunWalkthrough] = useState(false);
  const handleWalkthroughEnd = () => {
    // change walkthrough status api
    userApi.changeWalkthroughUser(data?.user?._id).then(() => {
      setRunWalkthrough(false);
      setLocalStorageItem('data', {
        ...data,
        user: {
          ...data?.user,
          walkthrough: true,
        },
      });
    }).catch((error) => dispatch(setErrorNotification(error?.response?.data)));
  };
  const handleCallback = (props) => {
    const {
      index,
      action,
      lifecycle,
      step,
      status,
      type,
    } = props;
    if (action === 'skip') {
      handleWalkthroughEnd();
    }
    if (action === 'update' && lifecycle === 'tooltip' && step.target === '.my-content-link') {
      navigate('/admin/templates');
    }
    if (action === 'next' && lifecycle === 'complete') {
      const nextPage = nextRoutes.find((val) => val.key === step.target);
      if (nextPage) {
        navigate(nextPage.value);
      }
      setStepIndex(index + 1);
    }
    if (action === 'next' && lifecycle === 'init' && type === 'error:target_not_found') {
      setStepIndex(index + 1);
    }
    if (action === 'prev' && lifecycle === 'complete') {
      const prevPage = backRoutes.find((val) => val.key === step.target);
      if (prevPage) {
        navigate(prevPage.value);
      }
      setStepIndex(index - 1);
    }
    if (action === 'prev' && lifecycle === 'init' && type === 'error:target_not_found') {
      setStepIndex(index - 1);
    }
    if (status === 'finished') {
      handleWalkthroughEnd();
    }
  };
  useEffect(() => {
    const style = document.createElement('style');
    style.id = 'recaptcha-style';
    document.head.appendChild(style);
    if (locate.pathname.startsWith('/admin')) {
      style.innerHTML = '.grecaptcha-badge { visibility: hidden; }';
    } else {
      style.innerHTML = '';
    }

    return () => {
      document.head.removeChild(style);
    };
  }, [locate.pathname]);

  useEffect(() => {
    if (data?.user) {
      setRunWalkthrough(!data?.user?.walkthrough);
    } else {
      setRunWalkthrough(false);
    }
  }, []);
  return (
    <div>
      <Joyride
        steps={WalkthroughSteps(currentLanguageCode, t)}
        continuous
        stepIndex={stepIndex}
        run={runWalkthrough
          && !currentPath?.includes('/admin/templates/')
          && !currentPath?.includes('/login')}
        callback={handleCallback}
        showSkipButton
        showProgress
        disableOverlayClose
        locale={{
          back: t('back'),
          close: t('next'),
          last: t('finish'),
          next: t('next'),
          skip: t('skip'),
        }}
        styles={styles}
      />
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
        <Routes>
          <Route path="/" exact element={<Navigate to="/login" />} />
          <Route exact path="/login" element={<Login setRunWalkthrough={setRunWalkthrough} />} />
          <Route exact path="/register" element={<RegisterNew />} />
          <Route exact path="/not-found" element={<NotFoundPage />} />
          <Route exact path="/forgot-password" element={<ForgotPasswordNew />} />
          <Route exact path="/reset-password" element={<ResetPasswordNew />} />
          <Route exact path="/admin/templates/edit-content/:id" element={<TableRenderPage />} />
          <Route exact path="/admin/templates/view-html/:id" element={<HtmlRenderPage />} />
          <Route exact path="/admin/templates/view-image/:id" element={<ViewImage />} />
          <Route
            path="/admin"
            element={(
              <WrapperRoutes
                setStepIndex={setStepIndex}
                setRunWalkthrough={setRunWalkthrough}
              />
            )}
          >
            {
              routsData.map((route) => (
                <Route path={route.path} key={route?.path}>
                  {
                    route?.children?.map((child) => (
                      <Route
                        path={child.path}
                        key={child?.path}
                        element={(
                          <AuthGuard
                            permission={child.permission}
                            Component={child.component}
                          />
                        )}
                      />
                    ))
                  }
                </Route>
              ))
            }
          </Route>
          {/* widget */}
          <Route
            path="/admin/apps"
            element={(
              <WrapperRoutes
                setStepIndex={setStepIndex}
                setRunWalkthrough={setRunWalkthrough}
              />
            )}
          >
            {/* <Route exact path="/admin/apps" element={<Widget />} /> */}
            {
              routsData.map((route) => (
                <Route path={route.path} key={route?.path}>
                  {
                    route?.children?.map((child) => (
                      <Route
                        path={child.path}
                        key={child?.path}
                        element={(
                          <AuthGuard
                            permission={child.permission}
                            Component={child.component}
                          />
                        )}
                      />
                    ))
                  }
                </Route>
              ))
            }
          </Route>
          <Route path="/admin" element={<WrapperRoutes2 />}>
            {/* <Route path="my-content/view/:id" element={<ContentView />} /> */}
          </Route>
          <Route path="/*" element={<NotFoundPage />} />
        </Routes>
      </GoogleReCaptchaProvider>
      <Notification />
      <NotificationMessage />
    </div>
  );
}
Router.propTypes = {
  index: PropTypes.number,
  action: PropTypes.string,
  lifecycle: PropTypes.string,
  step: PropTypes.shape({
    target: PropTypes.string,
  }),
  status: PropTypes.string,
  type: PropTypes.string,
};
// WrapperRoutes.propTypes = {
//   setStepIndex: PropTypes.node.isRequired,
//   setRunWalkthrough: PropTypes.node.isRequired,
// };
Router.defaultProps = {
  index: undefined,
  action: undefined,
  lifecycle: undefined,
  step: undefined,
  status: undefined,
  type: undefined,
};

export default Router;
